import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { VMPSiteMap, VMPSiteDiagram } from '@src/types/VMPSiteMap'

interface Options {
  vmpId: number,
  serialId: number,
  siteMap: VMPSiteMap,
}

export const apiVMPAddSiteMap = (options: Options) => {
  const { vmpId, serialId, siteMap } = options
  const data = {
    ...siteMap,
  }
  const axOptions = {
    method: 'POST',
    url: `${BASE_API_URL}/v2/vmp/${vmpId}/sites`,
    data,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}